import React from 'react';
// @ts-ignore
import styles from './PernamentMedicationItem.module.scss';
import Text from '../../../../Components/Base/Text/Text';
import { SelectValue } from '../../../../Components/Base/Select/Select';

export type PermanentMedicamentHVLP = {
	item: {
		id: string;
		lim: null;
		code: string;
		form: string;
		name: string;
		doping: string;
		addition: string;
		strength: string;
		packaging: string;
		dispensing: string;
		hasLimitations: boolean;
		dispensingTermItem: SelectValue;
		hasIndicationLimitations: boolean;
		hasSpecialityLimitations: boolean;
	};
	manual: string;
	payment: SelectValue;
	formType: string;
	quantity: number;
	diagnosis: SelectValue;
	insuranceType: SelectValue;
	requestNumber: number;
	associatedDiagnosis: SelectValue;
};

interface Props {
	item: PermanentMedicamentHVLP;
}

const PermanentMedicationHVLPItem: React.FC<Props> = ({ item }) => {
	const { name, addition, strength, form, packaging, code } = item.item;
	const { quantity, payment, manual } = item;

	return (
		<div className={styles.content}>
			<div className={styles.medicament}>
				<div className={styles.title}>
					{name} <span>{addition}</span>
				</div>
			</div>
			<div className={styles.moreInfo}>
				{strength && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.strength'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{strength}</div>
					</div>
				)}
				{form && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.form'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{form}</div>
					</div>
				)}
				{packaging && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.packaging'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{packaging}</div>
					</div>
				)}
				{code && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.code'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{code}</div>
					</div>
				)}
				{quantity && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.amount'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{quantity}</div>
					</div>
				)}
				{payment.value && typeof payment.value === 'string' && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.payment'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{payment.value}</div>
					</div>
				)}
				{manual && (
					<div className={styles.moreInfoItem}>
						<Text
							tx='component.ePrescription.dosage'
							firstUpper
							className={styles.title}
						/>
						<div className={styles.text}>{manual}</div>
					</div>
				)}
			</div>
		</div>
	);
};

export default PermanentMedicationHVLPItem;
